import { getCurrentUserId } from '@travel-frontend/user-id';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { wishlistMetaState } from '../../../../components/Wishlist/redux/wishlist-meta/WishlistMetaState.js';
import { useAuthentication } from '../../../../hooks/index.js';
export const useWishlistIdentifier = () => {
  const sessionId = getCurrentUserId();
  const {
    isLoggedIn,
    userInfo,
    isStatusPending
  } = useAuthentication();
  const {
    syncedCustomerId
  } = useSelector(wishlistMetaState);
  const [isStatusEverChecked, setIsStatusEverChecked] = useState(!isStatusPending);
  if (!isStatusEverChecked && !isStatusPending) setIsStatusEverChecked(true);
  return useMemo(() => {
    if (isLoggedIn && syncedCustomerId === userInfo?.customerID) {
      return {
        id: userInfo?.customerID,
        type: 'customer'
      };
    }
    if (!isLoggedIn && isStatusEverChecked && sessionId) {
      return {
        id: sessionId,
        type: 'session'
      };
    }
    return {
      id: null,
      type: null
    };
  }, [sessionId, isLoggedIn, userInfo, syncedCustomerId, isStatusEverChecked]);
};